export function getCurrentDateTime(isObject: true): {
  year: number;
  month: string;
  day: string;
  hours: string;
  minutes: string;
};

export function getCurrentDateTime(isObject?: false): string;

export function getCurrentDateTime(isObject = false) {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  return isObject
    ? { year, month, day, hours, minutes }
    : `${year}-${month}-${day}T${hours}:${minutes}`;
}
